import { assoc, compose, pick } from 'ramda'

const cleanSelectedUsers = value => {
  if (!value) return value
  return value.map(value => {
    return {
      id: value.id,
      name: value.name
    }
  })
}

const cleanFilters = (filters = {}) => {
  return {
    ...filters,
    users:
      filters?.users?.type === 'selected'
        ? { selected: cleanSelectedUsers(filters?.users?.selected), type: filters?.users?.type }
        : filters.users
  }
}

const cleanValue = value => {
  return compose(
    JSON.stringify,
    pick(['days_limit', 'distance_radius', 'filters', 'label', 'conditions']),
    assoc('days_limit', Number(value.days_limit)),
    assoc('distance_radius', value?.distance_radius ? Number(value?.distance_radius * 1000) : null),
    assoc('filters', cleanFilters(value.filters)),
    assoc('label', value?.conditions.placeLevel?.resume ?? ''),
    assoc('conditions', cleanCondition(value))
  )(value)
}

const cleanCondition = value => {
  return compose(
    pick(['placeLevelType', 'placeLevel']), //
    assoc('placeLevelType', value?.conditions?.placeLevelType),
    assoc(
      'placeLevel',
      compose(
        pick(['id', 'levelId', 'name', 'resume', 'placeLevelsResume', 'type']), //
        assoc('id', value.conditions?.placeLevel?.id),
        assoc('levelId', value.conditions?.placeLevel?.levelId),
        assoc('name', value.conditions?.placeLevel?.name),
        assoc('resume', value.conditions?.placeLevel?.resume),
        assoc('placeLevelsResume', value.conditions?.placeLevel?.placeLevelsResume)
      )(value)
    )
  )(value)
}

export const cleanRequest = form =>
  compose(
    pick(['id', 'name', 'value']), //
    assoc('value', cleanValue(form.value))
  )(form)
